import React, { ElementType } from 'react';

import { Divider, Flex, IconProps } from '@chakra-ui/react';

import { PaperWithShadow } from 'uiToolkitV1/Paper';
import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

interface Props {
  children: React.ReactNode;
  buttonComp?: React.ReactNode;
  heading: string;
  subHeading: string;
  hasButton?: boolean;
  showDivider?: boolean;
  Icon: ElementType<IconProps>;
}

const SettingsCardTemplate = ({ children, heading, subHeading, Icon, hasButton, buttonComp, showDivider }: Props) => (
  <PaperWithShadow p="12px" mb="12px">
    <Flex alignItems="center">
      {showDivider && <Icon color="#666666" boxSize="24px" />}
      <Flex alignItems="center" justifyContent="space-between" flex="1">
        <Flex flexDirection="column" ml="12px">
          <TextBodyMedium bold>{heading}</TextBodyMedium>
          <TextLabel color="#666666">{subHeading}</TextLabel>
        </Flex>
        {hasButton && <Flex mr="25px">{buttonComp}</Flex>}
      </Flex>
    </Flex>
    {showDivider && <Divider my="20px" opacity={1} color="#CFD7DF" />}
    {children}
  </PaperWithShadow>
);

export { SettingsCardTemplate };
